import { createWordpressBlogFetcher } from '@webplatform/asbis-ui/integrations/nuxt';

export default function createDataLoaders(api, httpClient) {
  const fetchProducts = async (productIds) => {
    try {
      const params = {
        search: `id:${productIds.join(',')}`,
        searchFields: 'id:in',
        limit: 0,
      };

      const { data } = await api.productService.getAllProducts(params);
      return data ?? [];
    } catch (error) {
      console.error('Error fetching products:', error);
      return [];
    }
  };

  const fetchPromotion = async (promoId) => {
    try {
      const { data } = await httpClient(`/api/promotions/${promoId}`);
      return data ?? [];
    } catch (error) {
      console.error('Error fetching promotion:', error);
      return [];
    }
  };

  const fetchInstagramPosts = async (limit) => {
    try {
      const { data } = await httpClient('/api/social/posts', {
        query: {
          network: 'instagram',
          ...(limit && { limit: String(limit) }),
        },
      });
      return data ?? [];
    } catch (error) {
      console.error('Error fetching instagram posts:', error);
      return [];
    }
  };

  const fetchPages = async (tagId, lang = 'en') => {
    try {
      const { data } = await httpClient('/api/pages/list', {
        query: { type: 'page', tag_ids: [tagId], lang },
      });
      return data ?? [];
    } catch (error) {
      console.error('Error fetching pages:', error);
      return [];
    }
  };

  const fetchBlogPosts = createWordpressBlogFetcher({
    request: (url, options) => $fetch(url, options),
    timeout: 5000,
  });

  return {
    fetchProducts,
    fetchPromotion,
    fetchInstagramPosts,
    fetchPages,
    fetchBlogPosts,
  };
}
